import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AutocompleteService } from '../components/autocomplete/autocomplete.service';

@Injectable({
  providedIn: 'root'
})
export class SchoolService implements AutocompleteService {

  constructor(private httpClient: HttpClient) { }

  fetch(params?: HttpParams): Promise<any> {
    return this.httpClient.get<any[]>('/api/SchoolApi/SearchSchoolsForRegistration', {params: params}).toPromise();
  }

  searchSchools(zip, terms) {
    return this.httpClient.post('/api/SchoolApi/SearchSchoolsForRegistration', {ZipCode: zip, Terms: terms});
  }

  checkForExistingSubOfType(type, sportName, schoolId)
  {
    return this.httpClient.post('/api/SchoolApi/DoesSchoolHaveTargetSubtype', {SchoolId: schoolId, Type: type, Sport: sportName});
  }

}
